class GalleryGrid extends HTMLElement {
  constructor() {
    super();
    this._bp = 767;
    this._isMobile = null;
    this._onResizeBound = null;
    this._delegatedBound = false;
    this.init();
  }

  init() {
    this.bindDelegatedEvents();
    this.onResize();
    setTimeout(() => {
    }, 0);
  }

  bindDelegatedEvents() {
    if (this._delegatedBound) return;
    this._delegatedBound = true;

    this.addEventListener("click", (e) => {
      const btn = e.target.closest(".overlay-btn");
      if (btn) {
        e.preventDefault();
        window.pauseAllMedia(this);

        const itemContainer =
          btn.closest(".slider-external-video") || btn.closest(".slider-video");
        if (!itemContainer) return;

        const tpl = itemContainer.querySelector("template.video-template");
        if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;

        const content = document.createElement("div");
        content.appendChild(tpl.content.firstElementChild.cloneNode(true));

        const box = itemContainer.querySelector(".video-box");
        if (!box) return;
        box.classList.remove("d-none");
        const node = content.querySelector("video, iframe");
        if (node) box.appendChild(node);
        btn.remove();
        return;
      }

      if (
        e.target.closest(
          ".slider-model, .slider-image, .slider-video, .slider-external-video"
        )
      ) {
        window.pauseAllMedia(this);
      }
    });
  }

  onResize() {
    const calcIsMobile = () => window.innerWidth <= this._bp;

    this._isMobile = calcIsMobile();
    this.actionResize(this._isMobile);

    if (this._onResizeBound) {
      window.removeEventListener("resize", this._onResizeBound);
    }

    this._onResizeBound = () => {
      const next = calcIsMobile();
      if (next !== this._isMobile) {
        this._isMobile = next;
        this.actionResize(this._isMobile);
      }
    };

    window.addEventListener("resize", this._onResizeBound);
  }

  _norm(str) {
    return (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  _isVideo(node) {
    return node.classList.contains('slider-video') || 
           node.classList.contains('slider-external-video');
  }

  _altMatch(alt, key) {
    const a = this._norm(alt);
    const k = this._norm(key);

    if (!k) return true;
    if (!a) return false;

    if (a.includes(k)) return true;

    const tokens = k.split(/[\|\/,]+/).map(s => s.trim()).filter(Boolean);
    if (tokens.length > 1) {
      return tokens.some(tok => tok && a.includes(tok));
    }

    return false;
  }

  loadContent() {
    const tpl = this.querySelector("template");
    if (!tpl) return "";

    const wrap = tpl.content.querySelector(".content-items");
    if (!wrap) return "";

    const key = this.dataset.variantSelected;

    if (!key) {
      return wrap.innerHTML;
    }

    const selector =
      ".slider-image, .slider-video, .slider-external-video, .slider-model";

    const out = document.createElement("div");
    wrap.querySelectorAll(selector).forEach((node) => {
      const alt = node.dataset.alt || "";
      // 视频始终显示，不受 alt 筛选影响
      if (this._isVideo(node)) {
        out.appendChild(node.cloneNode(true));
      } else if (this._altMatch(alt, key)) {
        out.appendChild(node.cloneNode(true));
      }
    });

    if (!out.querySelector(selector)) {
      return wrap.innerHTML;
    }

    return out.innerHTML;
  }

  actionResize(isMobile) {
    const container = this.querySelector(".gallery-grid-js");
    if (!container) return;

    let content = this.loadContent();
    if (!content) return;

    if (this.slider) {
      this.destroy();
      this.slider = null;
    }

    container.innerHTML = "";

    if (isMobile) {
      const sl = document.createElement("div");
      sl.classList.add("slide-container");

      container.classList.remove(
        "tablet-2",
        "mb-1",
        "grid-cols",
        "gap-small",
        "row-as-column-gap"
      );

      sl.innerHTML = content;
      container.appendChild(sl);

      this.initSlide();
    } else {
      container.classList.add(
        "tablet-2",
        "mb-1",
        "grid-cols",
        "gap-small",
        "row-as-column-gap"
      );
      container.innerHTML = content;
    }
  }
}
customElements.define("gallery-grid", GalleryGrid);
